import script from "./FormularioReceitaGeral.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioReceitaGeral.vue?vue&type=script&setup=true&lang=js"

import "./FormularioReceitaGeral.vue?vue&type=style&index=0&id=4a46ac64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a46ac64"]])

export default __exports__